import { getCurrentDomainFromConfig } from '@/utils/domain'
import { getTrackingKey } from '@/utils/api'

import API from '@/api/base'

class ApplePayV2 extends API {
  validateAppleSession = (validationUrl) => {
    return this.fetcher(
      {
        method: 'POST',
        trackingKey: getTrackingKey(this.uri, 'apple_pay_validate'),
        path: this.uri + '/validate',
        data: { validationUrl, domain: getCurrentDomainFromConfig() },
      },
      {
        options: {
          attachCkoPublicKey: true,
        },
      }
    )
  }
}

export default new ApplePayV2('/repayment/v2/applepay')
